import { Input } from 'antd';
import { ThemedButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import styled from 'styled-components';

export const UserFieldWrap = styled.div`
  .af-superadmin-userfields-caption {
    font-size: 16px;
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 30px 0px;
  gap: 10px;
  .af-input-userfields-attribute-title-head {
    margin-bottom: 0px;
  }
  @media (max-width: 750px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const Box = styled.div`
  width: 95%;
  min-width: 300px;
  border: 1px solid #ccc;
  border-radius: 8px;
  @media (max-width: 750px) {
    width: 100%;
  }
`;
export const BoxConatiner = styled.div`
  width: 50%;
  @media (max-width: 750px) {
    width: 100%;
  }
`;
export const LeftBoxConatiner = styled.div`
  width: 90%;
  margin: 0px 0px 0px auto;
  @media (max-width: 750px) {
    width: 100%;
  }
`;
export const LeftBoxWrap = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 450px;
  width: 50%;
  @media (max-width: 750px) {
    margin-bottom: 20px;
    height: 100px;
    width: 100%;
  }
`;

export const Header = styled.div`
  font-size: 16px;
  padding: 10px 20px;
  text-align: center;
  background: var(--bg-button-default-color);
  color: var(--button-text-color);
  border-radius: 7px 7px 0px 0px;
  display: flex;
  justify-content: space-between;
`;

export const List = styled.div`
  padding: 20px;
  height: 350px;
  overflow: auto;
`;

export const ButtonStyle = styled(ThemedButton)`
  margin: 10px 0;
  padding: 5px 10px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const TransferButton = styled(ButtonStyle)`
  margin: 0 10px;
`;

export const TransferContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;
export const BoxListWrap = styled.div`
  cursor: pointer;
  margin-bottom: 10px;
`;
export const BoxListItem = styled.div`
  font-size: 16px;
`;
export const BoxHeadItem = styled.div`
  font-size: 16px;
`;
export const SearchWrap = styled.div`
  margin: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 0 auto;
  justify-content: flex-end;
`;
export const FormWrap = styled.div`
  width: 100%;
`;
export const FormFieldWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const InputField = styled(Input)`
  margin-right: 5px;
  height: 40px;
`;
